module.exports = __webpack_public_path__ + "static/img/logo.94aee440.png";